declare global {
  interface Window {
    L?: any;
  }
}

const LEAFLET_CSS_ID = 'leaflet-css';
const LEAFLET_JS_ID = 'leaflet-js';
const LEAFLET_CSS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
const LEAFLET_JS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';

export const DEFAULT_LEAFLET_CENTER: [number, number] = [
  51.509865,
  -0.118092,
];

let leafletLoader: Promise<void> | null = null;

export const ensureLeafletAssets = () => {
  if (leafletLoader) return leafletLoader;

  if (typeof window === 'undefined') {
    leafletLoader = Promise.resolve();
    return leafletLoader;
  }

  leafletLoader = new Promise<void>((resolve, reject) => {
    const doc = document;
    if (!doc.getElementById(LEAFLET_CSS_ID)) {
      const link = doc.createElement('link');
      link.id = LEAFLET_CSS_ID;
      link.rel = 'stylesheet';
      link.href = LEAFLET_CSS_URL;
      doc.head.appendChild(link);
    }

    if (window.L) {
      resolve();
      return;
    }

    const existingScript = doc.getElementById(
      LEAFLET_JS_ID
    ) as HTMLScriptElement | null;

    if (existingScript) {
      existingScript.addEventListener('load', () => resolve());
      existingScript.addEventListener('error', (err) => reject(err));
      return;
    }

    const script = doc.createElement('script');
    script.id = LEAFLET_JS_ID;
    script.async = true;
    script.src = LEAFLET_JS_URL;
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', (err) => reject(err));
    doc.body.appendChild(script);
  });

  return leafletLoader;
};

